Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.CustomTextsFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/custom_text/custom_texts_filter"]

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facet = @options.facet
    @customTexts = @options.customTexts

  render: ->
    @$el.html(@template())
    _.each @customTexts, (name) =>
      @$el.append new GenericTextFilterView($.extend({ text: name }, @options)).render().el
    return this

  destroy: ->
    this.remove()
    return false

class GenericTextFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/custom_text/custom_text_filter"]

  events:
    'click #add-keyword': '_apply'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @text = @options.text
    @name = _.str.humanize(@text)

  destroy: ->
    this.remove()
    return false

  render: ->
    @$el.html(@template(self: this))
    return this

  _apply: (event) =>
    text = @$el.find("#keyword").val().trim()
    return unless text != ''
    @searchQuery.addCustomText(@text, text)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
